import { AxiosResponse } from 'axios';

import { request } from '@cvt/clients/baseClient';


const usersApiBaseUrl = import.meta.env.VITE__CVT_API_URL;

const getSettings = (): Promise<AxiosResponse<Settings.Settings>> => {
  return request({
    options: {
      url: `${usersApiBaseUrl}/settings/`,
      method: 'GET',
    },
  }).then((data: AxiosResponse<Settings.Settings>) => ({
    ...data,
    data: data.data,
  }));
};

export const settingsClient = {
  getSettings: getSettings,

};
